<template>
  <div id="collection">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">相簿合集列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">相簿</li>
              <li class="breadcrumb-item active">相簿合集列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-banner" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-8"></div>
          <div class="col-sm-2">
            <button
              type="button"
              class="btn btn-block btn-primary btn-sm"
              value="建立相簿合集"
              @click="createCollection()"
            >
              <i class="nav-icon fas fa-plus fa-sm mr-1"></i> 建立相簿合集
            </button>
          </div>
          <div class="col-sm-2">
            <button
              type="button"
              class="btn btn-block btn-primary btn-sm"
              data-toggle="modal"
              @click="showQry"
            >
              <i class="nav-icon fas fa-filter fa-sm mr-1"></i> 篩選條件
            </button>
          </div>
          <!-- /.col-12 -->
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs"></div>
              <div class="card-body">
                <el-table
                  :data="GetList"
                  v-loading="loading"
                  border
                  row-key="id"
                >
                  <el-table-column
                    width="300"
                    label="相簿合集"
                    prop="sgL_PhotoName"
                  >
                    <template slot-scope="scoped">
                      <div class="b-collection-head">
                        <div class="b-album-block mr-2">
                          <div class="b-album-thumbnail">
                            <div class="b-album-responsive">
                              <div class="b-album-sizer">
                                <div
                                  class="b-album-image"
                                  :style="{
                                    backgroundImage:
                                      'url(' +
                                      `${scoped.row.sgL_ImageUrl}` +
                                      ')',
                                  }"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <span class="b-title"
                          ><router-link
                            target="_blank"
                            v-bind:to="{
                              name: `collection`,
                              query: {
                                id: scoped.row.id,
                              },
                            }"
                          >
                            {{ scoped.row.sgL_PhotoName }}</router-link
                          ></span
                        >
                        <span class="b-subtext">
                          {{ scoped.row.sgL_Content }}
                        </span>
                        <span class="b-tag">
                          <a
                            href="javascript:void(0);"
                            v-for="aaa in scoped.row.sgL_KeywordF"
                            :key="aaa"
                          >
                            {{ aaa }}
                          </a>
                        </span>
                      </div>
                      <div>
                        <span
                          class="b-tag"
                          v-if="!IsNullOrEmpty(scoped.row.sgL_Keyworld)"
                        >
                          <a
                            href="javascript:void(0);"
                            v-for="key in scoped.row.sgL_Keyworld.split(',')"
                            :key="key"
                            v-if="!IsNullOrEmpty(key)"
                          >
                            {{ key }}
                          </a>
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="相簿數">
                    <template slot-scope="scoped">
                      <span class="b-username">
                        {{ scoped.row.sgL_PhotoalbumCount }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="攝影師數" prop="sgL_GraphyCount">
                    <template slot-scope="scoped">
                      <span class="b-username">
                        {{ scoped.row.sgL_GraphyCount }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="相片數" prop="sgL_PhotoCountF">
                  </el-table-column>
                  <el-table-column
                    label="建立日期 / 狀態"
                    prop="sgL_PG_CAddTimerF"
                  >
                    <template slot-scope="scoped">
                      <div>
                        {{ scoped.row.sgL_PG_CAddTimerF }}
                      </div>
                      <div>
                        <span
                          v-if="!scoped.row.sgL_IsShow"
                          class="b-subtext b-unlisted"
                        >
                          不公開
                        </span>
                        <span v-else class="b-subtext b-public"> 公開 </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="最後修改日期"
                    prop="sgL_UpdateTimeF"
                  ></el-table-column>
                  <el-table-column
                    label="最後修改人員"
                    prop="sgL_UpdateName"
                  ></el-table-column>
                  <el-table-column
                    label="瀏覽量"
                    prop="sgL_ViewCountF"
                  ></el-table-column>
                  <el-table-column
                    label="收藏"
                    prop="sgL_PG_CTotalLike"
                  ></el-table-column>
                  <el-table-column
                    label="分享"
                    prop="sgL_PG_CTotalShare"
                  ></el-table-column>
                  <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                      <span class="b-operate-btn b-edit"
                        ><a
                          href="javascript:void(0);"
                          @click="setjx(scope.row)"
                        >
                          <span v-if="!scope.row.sgL_IsTop">設為精選</span>
                          <span v-else>從精選移除</span>
                        </a></span
                      >
                      <span class="b-operate-btn b-edit"
                        ><a
                          href="javascript:void(0);"
                          @click="createCollection(scope.row.id)"
                        >
                          編輯
                        </a></span
                      >
                      <span class="b-operate-btn b-edit"
                        ><a href="javascript:void(0);" @click="del(scope.row)">
                          刪除
                        </a></span
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
            </div>
            <div class="row">
              <div class="col-lg-4 offset-lg-7">
                <!--  引用分页组件 -->
                <pagination
                  v-if="pageParams.pageshow"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
    <div
      class="modal fade"
      id="modal-album--filter"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">篩選條件</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>相簿合集名稱</label>
              <div class="input-group mb-3">
                <input class="form-control" v-model="qryParams.p1" />
              </div>
            </div>
            <div class="form-group mb-3">
              <label>包含相簿標題</label>
              <div class="input-group mb-3">
                <input class="form-control" v-model="qryParams.p2" />
              </div>
            </div>
            <div class="form-group mb-3">
              <label>包含上傳者</label>
              <div class="form-group">
                <input class="form-control" v-model="qryParams.p3" />
              </div>
            </div>
            <div class="form-group mb-3">
              <label>建立日期介乎</label>
              <div class="input-group">
                <el-date-picker
                  v-model="qryParams.Date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="開始日期"
                  end-placeholder="結束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>包含關鍵字</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control float-right"
                  v-model="qryParams.p4"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-toggle="modal"
              data-dismiss="modal"
              @click="handleCurrentChange(1)"
            >
              篩選
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <div class="modal fade" id="modal-collection--remove">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <p>
              確認刪除相簿合集<b>「{{ delInfo.title }}」</b>？<br />
              <b>相簿合集一旦刪除，將無法復原。</b>
            </p>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              取消
            </button>
            <button
              type="button"
              class="btn btn-danger collection--remove---success"
              data-dismiss="modal"
              @click="delConfirm"
            >
              是，刪除
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <div class="modal fade" id="modal-featured--add">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <p>
              將相簿合集<b>「{{ setInfo.title }}」</b>設為精選？
            </p>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-default"
              style="margin-left: initial"
              data-dismiss="modal"
            >
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              style="margin-left: initial"
              @click="setjxConfirm"
            >
              設為精選合集
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  data() {
    return {
      qryParams: {
        p1: "",
        p2: "",
        p3: "",
        Date: null,
        p4: "",
      },
      SocialList: null,
      pageParams: {
        pageshow: true,
        currentPage: 1, //當前頁
        total: 0, //總條數
        limit: 5, //顯示條數
      },
      loading: false,
      delInfo: {
        id: 0,
        title: "",
      },
      setInfo: {
        id: 0,
        title: "",
      },
    };
  },
  created() {
    this.handleCurrentChange(1);
  },
  methods: {
    setjx(item) {
      this.setInfo.title = item.sgL_PhotoName;
      this.setInfo.id = item.id;
      $("#modal-featured--add").modal("show");
    },
    setjxConfirm() {
      let params = {
        id: this.setInfo.id,
      };
      this.$api.albumApi.AdminPhotoCollectionUpdateTop(params).then((res) => {
        if (res.data.success) {
          Message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.handleCurrentChange(1);
        } else {
          Message({
            type: "error",
            message: res.data.error.message,
          });
        }
      });
    },
    delConfirm() {
      let params = {
        Id: this.delInfo.id,
      };
      this.$api.albumApi.AdminPhotoCollectionDelete(params).then((res) => {
        if (res.data.success) {
          Message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.handleCurrentChange(1);
        } else {
          Message({
            type: "error",
            message: res.data.error.message,
          });
        }
      });
    },
    del(item) {
      this.delInfo.title = item.sgL_PhotoName;
      this.delInfo.id = item.id;
      $("#modal-collection--remove").modal("show");
    },
    createCollection(id) {
      this.$router.push({
        name: "AdminCollectionEdit",
        query: { id },
      });
    },
    clearQry() {
      this.qryParams.p1 = "";
      this.qryParams.p2 = "";
      this.qryParams.p3 = "";
      this.qryParams.Date = null;
      this.qryParams.p4 = "";
    },
    showQry() {
      this.clearQry();
      $("#modal-album--filter").modal("show");
    },
    getSocialList() {
      let params = {
        SGL_PhotoName: this.qryParams.p1,
        SGL_PG_CName: this.qryParams.p2,
        SGL_Mem_DisplayName: this.qryParams.p3,
        CreateTime: this.qryParams.Date,
        SGL_Keyword: this.qryParams.p4,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
      };
      this.loading = true;
      this.$api.albumApi
        .AdminPhotoCollectionGetAll(params)
        .then((res) => {
          if (res.data.success) {
            this.SocialList = res.data.result.items;
            this.pageParams.total = res.data.result.totalCount;
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch()
        .then((obj) => {
          this.loading = false;
        });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getSocialList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getSocialList();
    },
  },
  components: {
    pagination,
  },
  computed: {
    GetList() {
      return this.SocialList;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminAlbum/Collection.vue